/**
 * Build-time env (CRA REACT_APP_*). VPS Docker sets REACT_APP_API_BASE="" so the
 * browser uses same-origin /api/ (system nginx → 127.0.0.1:4001).
 */

/** Punycode defaults when REACT_APP_* are unset at build time. */
export const DEFAULT_BOOKING_HOST =
  process.env.REACT_APP_BOOKING_HOST?.trim() || 'booking.xn--syluxtravel-e2b.com';

export const DEFAULT_PAYMENT_HOST =
  process.env.REACT_APP_PAYMENT_HOST?.trim() || 'payment.xn--syluxtravel-e2b.com';

export function envBookingHost(): string | undefined {
  const v = process.env.REACT_APP_BOOKING_HOST?.trim();
  return v || undefined;
}

export function envPaymentHost(): string | undefined {
  const v = process.env.REACT_APP_PAYMENT_HOST?.trim();
  return v || undefined;
}

export function envQuoteEmailBannerUrl(): string | undefined {
  const v = process.env.REACT_APP_QUOTE_EMAIL_BANNER_URL?.trim();
  return v || undefined;
}

/**
 * Origin for fetch() — no trailing slash.
 * - "" → relative /api/... (production behind nginx on admin/booking/payment)
 * - dev, unset → "" (CRA proxy to localhost:4001)
 * - unset in non-dev build → http://localhost:4001 (local node without Docker env)
 */
export function resolveApiBase(): string {
  if (process.env.REACT_APP_API_BASE !== undefined) {
    return String(process.env.REACT_APP_API_BASE).trim().replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'development') return '';
  return 'http://localhost:4001';
}

export const API_BASE = resolveApiBase();
